/** Fast, frame-rate-independent envelope for per-frame audio analyser readings. */
export function advanceWave(
  amplitude: number,
  level: number,
  active: boolean,
  speaking: boolean,
  elapsedMs: number
): number {
  const volume = Number.isFinite(level) ? Math.min(1, Math.max(0, level)) : 0;
  const target = active ? (speaking ? 0.05 : 0.02) + Math.sqrt(volume) * 0.85 : 0;
  const responseMs = target > amplitude ? 20 : 80;
  return amplitude + (target - amplitude) * (1 - Math.exp(-Math.max(0, elapsedMs) / responseMs));
}
